<template>
    <div class="user" @mouseleave="menuClose" @click="menuToggle">
        <div class="avatar" >
            <ui-image :src="getImgCDN(user?.photo)" alt="Avatar" design="circle" h="40" w="40" />
        </div>
        <div class="infos h-1430">
            <div class="name">{{user?.first_name}}</div>
            <div class="role">{{user?.perfil}}</div>
        </div>
        <div class="user-menu" :class="{'active': menu}">
            <button type="button" v-if="!mobile">
                <i class="fas fa-caret-down"></i>
            </button>
            <div class="options">
                <ul>
                    <li>
                        <router-link to="/perfil">
                            <i class="fas fa-caret-right"></i>
                            Meu Perfil
                        </router-link>
                    </li>
                    
                    <li>
                        <router-link 
                            v-if="$mx_userIsAdmin" 
                            to="/configuracoes/"
                        >
                            <i class="fas fa-caret-right"></i>
                            Configurações
                        </router-link>
                    </li>
                    <li>
                        <button type="button" @click="userLogout">
                            <i class="fas fa-caret-right"></i>
                            {{textLogout}}
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { uiImage } from '@/components/ui'
    import { mapGetters, mapActions } from 'vuex'
    import { helpersMixin, permissionsMixin } from '@/mixins'
    import { user } from '@/services/axios'

	export default {
        components: { uiImage },
        props: {
            mobile: {
                type: Boolean,
                default: false
            }
        },
        computed: mapGetters('auth', {
            user: 'getUser',
        }),
        mixins: [ helpersMixin, permissionsMixin ],
        data(){
            return {
                menu: false,
                textLogout: 'Sair'
            }
        },
        
        methods: {
            ...mapActions('auth', ['logout']),
            menuToggle(){
                this.menu = !this.menu
            },

            menuClose(){
                this.menu = false
            },
            userLogout(){
                this.logout()
                this.textLogout = 'Saindo...'
            },
            getAvatar(){
                user.me().then().catch((error) => {
                    console.error(error); 
                });
            }
        },
        created(){
            this.getAvatar()
        }
    };
</script>

<style lang="stylus" scoped>

    @import './styles.styl'
        
</style>